<ng-container [formGroup]="form">
  @for (subOption of $enabledSelectedSubOptions(); track subOption) {
    <div>
      <div class="option-field-container">
        <!-- TODO: Add back suboptions when implementation is ready -->
        <ng-container
          *ngTemplateOutlet="
            { title, details, link, location }[subOption];
            context: { form }
          "
        >
        </ng-container>
      </div>
    </div>
  }
  <div class="option-chips">
    @if (subOptions.length - $enabledSelectedSubOptions().length > 3) {
      <button
        mat-icon-button
        type="button"
        class="option-expand-button"
        (click)="toggleCollapse()"
      >
        <mat-icon>
          {{ isOptionsCollapsed ? "unfold_more" : "unfold_less" }}
        </mat-icon>
      </button>
    }
    <mat-chip-listbox
      multiple
      class="option-chips-listbox label-small"
      [class.collapsed]="isOptionsCollapsed"
    >
      @for (subOption of $enabledSubOptions(); track subOption) {
        <mat-chip-option
          class="option-chip"
          [value]="subOption"
          [selected]="$enabledSelectedSubOptions().includes(subOption)"
          [class.hidden]="$enabledSelectedSubOptions().includes(subOption)"
          (click)="showSubOption(subOption)"
        >
          <mat-icon matChipAvatar fontSet="material-symbols-outlined">
            {{ getSuboptionIcon(subOption) }}
          </mat-icon>
          {{ formatChipLabel(getSuboptionChipLabel(subOption)) }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>

  <ng-template #title>
    <div class="emoji-title-row">
      <mat-form-field
        appearance="outline"
        class="title-field"
        subscriptSizing="dynamic"
      >
        <mat-label>Title</mat-label>
        <input
          matInput
          formControlName="title"
          oncontextmenu="return false;"
          #titleInput
        />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="emoji-field"
      >
        @if (!form.controls.emoji.value) {
          <mat-label>❓</mat-label>
        }
        <input
          matInput
          readonly
          formControlName="emoji"
          [matMenuTriggerFor]="emojiMenu"
        />
      </mat-form-field>
    </div>
    @if (!alwaysVisibleSubOptions().has(SubOption.TITLE)) {
      <button
        type="button"
        mat-icon-button
        (click)="hideSubOption(SubOption.TITLE)"
      >
        <mat-icon>remove_circle_outline</mat-icon>
      </button>
    }
  </ng-template>

  <!-- TODO: Add back suboptions when implementation is ready -->

  <!-- <ng-template #duration>
    <ng-container [formGroup]="form">
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        subscriptSizing="dynamic"
        class="option-field"
      >
        <mat-label>Duration</mat-label>
        <input matInput type="number" formControlName="duration" />
        <span matTextSuffix>minutes</span>
      </mat-form-field>
      <button
        mat-icon-button
        (click)="hideSubOption(SubOption.DURATION)"
      >
        <mat-icon>remove_circle_outline</mat-icon>
      </button>
    </ng-container>
  </ng-template> -->

  <!-- <ng-template #maxSpots>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      subscriptSizing="dynamic"
      class="option-field"
    >
      <mat-label>Max spots</mat-label>
      <input matInput type="number" formControlName="maxSpots" />
    </mat-form-field>
    <button
      mat-icon-button
      (click)="hideSubOption(SubOption.MAX_SPOTS)"
    >
      <mat-icon>remove_circle_outline</mat-icon>
    </button>
  </ng-template> -->

  <!-- <ng-template #minSpots>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      subscriptSizing="dynamic"
      class="option-field"
    >
      <mat-label>Min spots</mat-label>
      <input matInput type="number" formControlName="minSpots" />
    </mat-form-field>
    <button
      mat-icon-button
      (click)="hideSubOption(SubOption.MIN_SPOTS)"
    >
      <mat-icon>remove_circle_outline</mat-icon>
    </button>
  </ng-template> -->

  <ng-template #link>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      subscriptSizing="dynamic"
      class="option-field on-surface-text"
    >
      <mat-label>Link</mat-label>
      <mat-icon matIconPrefix>link</mat-icon>
      <input matInput type="url" [formControl]="form.controls.link" />
    </mat-form-field>
    @if (!alwaysVisibleSubOptions().has(SubOption.LINK)) {
      <button
        type="button"
        mat-icon-button
        (click)="hideSubOption(SubOption.LINK)"
      >
        <mat-icon>remove_circle_outline</mat-icon>
      </button>
    }
  </ng-template>

  <ng-template #details>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      subscriptSizing="dynamic"
      class="option-field"
    >
      <mat-label>Description</mat-label>
      <input
        matInput
        autocomplete="off"
        [formControl]="form.controls.details"
      />
    </mat-form-field>
    @if (!alwaysVisibleSubOptions().has(SubOption.DETAILS)) {
      <button
        type="button"
        mat-icon-button
        (click)="hideSubOption(SubOption.DETAILS)"
      >
        <mat-icon>remove_circle_outline</mat-icon>
      </button>
    }
  </ng-template>

  <ng-template #location>
    <location-form
      class="option-field"
      [formPath]="['location']"
    ></location-form>
    @if (!alwaysVisibleSubOptions().has(SubOption.LOCATION)) {
      <button
        type="button"
        mat-icon-button
        (click)="hideSubOption(SubOption.LOCATION)"
      >
        <mat-icon>remove_circle_outline</mat-icon>
      </button>
    }
  </ng-template>
</ng-container>

<mat-menu #emojiMenu="matMenu" class="emoji-menu">
  <emoji-selector
    (click)="$event.stopPropagation()"
    (emojiSelected)="changeEmoji($event)"
  ></emoji-selector>
</mat-menu>
